import SuperJSON from "superjson";
import Id from "../types/Id";

export default class IntegrationId extends Id<"integration"> {}

SuperJSON.registerClass(IntegrationId, { identifier: "IntegrationId" });
